import styled from 'styled-components';

import HighlightText from 'components/HighlightedText';

export const Highlighted = styled(HighlightText)`
  & span {
    white-space: normal;
  }
`;
